import styled from '@emotion/styled';
import BaseFooter from '@layout/Footer/BaseFooter';
import { mediaQuery } from '@styles/index';
import React from 'react';

interface IconsFooterProps {}

const StyledBaseFooter = styled(BaseFooter)`
  background-color: var(--color-i-icon-dark-primary);
  @${mediaQuery.uptoMobile} {
    box-shadow: none;
  }
`;
const IconsFooter: React.FC<IconsFooterProps> = () => {
  return (
    <div id="unacademy-icons-footer">
      <StyledBaseFooter display isUnIcons />
    </div>
  );
};

IconsFooter.displayName = 'IconsFooter';

export default IconsFooter;
